module.exports = __webpack_public_path__ + "img/pod_dex.db0dd114.svg";